module.exports = __webpack_public_path__ + "static/img/cont3104.29fc530.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont3104.jpg
// module id = 2z99
// module chunks = 0